import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { GetUserVideo, getVideo } from '../../s3Func/s3Download';
import VideoWebcamRecorder from './Recorder';
import './PracticeSituation.css';
import { DragDropContainer, DropTarget } from 'react-drag-drop-container';
import { API } from 'aws-amplify';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import loading from './../../loading-gif-png-5.gif';
import { sleep } from '../../utils';

/**
 *  Creates and runs the practice section for Unit3 Module2
 *  Note: This code is reused in other modules as well
 * @param {*} props
 * @returns the HTML code for the practice section.
 */
const PracticeSituation = (props) => {
  // Initialize variables to be used later
  const dispatch = useDispatch();
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [practice, setPractice] = useState(true);
  const [question, setQuestion] = useState(false);
  const [recording, setRecording] = useState(false);
  const [takingVideo, setTakingVideo] = useState(false);
  const [introSound, setIntroSound] = useState('');
  const [animalVoice, setAnimalVoice] = useState('');
  const [animalTalk, setAnimaTalk] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [changeText, setChangeText] = useState('');
  const [option1, setOption1] = useState('');
  const [option2, setOption2] = useState('');
  const [option3, setOption3] = useState('');
  const [step, setStep] = useState(0);
  const [numVideo, setNumVideo] = useState(0);
  const [answerkey, setAnswerkey] = useState(null);
  const [showStart, setShowStart] = useState(true);

  const [numConversation1, setNumConversation1] = useState(0);
  const [instruction, setInstruction] = useState('');
  const [voice, setVoice] = useState('');
  const [displayAudio, setDisplayAudio] = useState(false);
  const [audioReady, setAudioReady] = useState(false);
  const [displayAnimal, setDisplayAnimal] = useState(false);
  const [animateAnimal, setAnimateAnimal] = useState('');
  const [influencerVideo, setInfluencerVideo] = useState('');
  const [playVideo, setPlayVideo] = useState('');
  const [displayInfluencer, setDisplayInfluencer] = useState(false);
  const [conversation1, setConversation1] = useState(false);
  const [conversation2, setConversation2] = useState(false);
  const [example, setExample] = useState(false);

  const [matchGame, setMatchGame] = useState(false);
  const [matchOptions, setMatchOptions] = useState(null);
  const [matchOptionsCopy, setMatchOptionsCopy] = useState(null);
  const [order1, setOrder1] = useState(null);
  const [order2, setOrder2] = useState(null);
  const [order3, setOrder3] = useState(null);
  const [order1Visibility, setOrder1Visibility] = useState('');
  const [order2Visibility, setOrder2Visibility] = useState('');
  const [order3Visibility, setOrder3Visibility] = useState('');

  const [speechBubble, setSpeechBubble] = useState('');
  const [secondAnimal, setSecondAnimal] = useState('');

  const [score, setScore] = useState(0);
  const [firstTime, setFirstTime] = useState(true);
  const [animalSize, setAnimalSize] = useState(props.bigAnimal  ? (props.lizard ? 'lizard' : 'bigAnimal') : 'animateAnimal15')

  async function reset() {
    setMatchGame(false)
    setOrder1(null)
    setOrder2(null)
    setOrder3(null)
    setOrder1Visibility('')
    setOrder2Visibility('')
    setOrder3Visibility('')
    setMatchOptions([...matchOptionsCopy])
    await sleep(1);
    setMatchGame(true)
  }

  const videoPlayer1 = {
    width: '370px',
    height: '655px',
    zIndex: 20,
  };

  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const Exit = generateImageUrl('images/Images/close.png')
  const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png')
  const bubble = generateImageUrl('images/Module19Images/practice/thought_bubble.png')

  const videoPlayer = {
    minWidth: '100%',
    minHeight: '100%',
    position: 'relative',
  };

  const isIOS = () => {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  useEffect(() => {
    setupGame();
  }, [step, numVideo]);

  useEffect(() => {
    if (!practice) {
      displayConversation();
    }
  }, [numConversation1]);

  const updateScore = async () => {
    try {
      await API.post('TIR', '/v3/student/result', {
        body: {
          student_id: login.studentid,
          metric: props.score,
          result: JSON.stringify({
            day: props.module.currentday,
            created: new Date().toISOString(),
            values: [{ value: score, target: props.score_target }],
          }),
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Sets up the game by selecting which possible answers to display in what order based on the current feeling.
  async function setupGame() {
    for (let x = 0; x < document.getElementsByClassName("optionImage16").length; x++){
      document.getElementsByClassName("optionImage16")[x].style.borderColor  = 'black'
    }
    // Sets the crab video and audio thatt should play based on the emotion'
    if (step < props.titles.length) {
      (async () => {
        setQuestion(false);
        setIntroSound('');
        setAnswerkey(null);
        setPractice(false);
        if (props.module16 && step === 0) {
          setPractice(true);
        }
        else{
          setIntroSound(getVideo(props.options[step].audioPrompt, login));
          setQuestion(true);
          if (props.module17 && step === 2) {
            let numArray = props.matchOptions;
            numArray = numArray
              .map((value) => ({ value, sort: Math.random() }))
              .sort((a, b) => a.sort - b.sort)
              .map(({ value }) => value);
            setMatchOptions([...numArray]);
            setMatchOptionsCopy([...numArray]);
            setChangeText(props.options[step].prompt);
            setMatchGame(true);
          } 
          else {
            let numArray = [];
            numArray = [
              props.options[step].correctMatch,
              props.options[step].incorrectMatches[0],
              props.options[step].incorrectMatches[1],
            ];
            numArray = numArray
              .map((value) => ({ value, sort: Math.random() }))
              .sort((a, b) => a.sort - b.sort)
              .map(({ value }) => value);
            setOption1(numArray[0]);
            setOption2(numArray[1]);
            setOption3(numArray[2]);
            setKeyword(props.options[step].correctMatch.title);
            if (props.module19) {
              setSpeechBubble(props.options[step].speechBubble);
              setSecondAnimal(props.options[step].animal);
            } else {
              setChangeText(props.options[step].prompt);
            }
            setPractice(true);
          }
        }
      })();
    } else {
      if (numVideo < props.names.length) {
        setInstruction(getVideo(props.instructions[numVideo], login));
        setVoice(getVideo(props.voices[numVideo], login));
        setPractice(false);
        setMatchGame(false);
        setRecording(true);
        if (numVideo !== 0) {
          await sleep(1000);
          setTakingVideo(true);
        } else {
          setAnimalVoice(getVideo(props.introductionMP3, login));
          setAnimateAnimal(props.introduction);
          setDisplayAnimal(true);
          updateScore();
          props.module.sectionCompleted = props.module.sectionCompleted + 1
        }
      } else {
        (async () => {
          setAnimalVoice(getVideo(props.practiceMessageAudio, login));
          await GetUserVideo(`influencers/${props.influencerid}/conversation_affirmation.mp4`).then((data) => {
            setInfluencerVideo(data);
          });
          setAnimateAnimal(props.practiceMessage);
          setDisplayAnimal(true);
        })();
      }
    }
  }

  // Finds out what the user selected, and uses that as the current answer.
  async function setAnswer(option, index) {
    for (let x = 0; x < document.getElementsByClassName("optionImage16").length; x++){
      document.getElementsByClassName("optionImage16")[x].style.borderColor  = 'black'
    }
    document.getElementsByClassName("optionImage16")[index].style.borderColor  = 'yellow'
    setAnswerkey(option);
    setAnimalVoice('');
    setAnimaTalk(false);
    setQuestion(false);
    setAnimalVoice(await getVideo(option.audioPrompt, login));
    setAnimaTalk(true);
  }

  async function setAnswer17(option, index) {
    for (let x = 0; x < document.getElementsByClassName("optionImage").length; x++){
      document.getElementsByClassName("optionImage")[x].style.borderColor  = 'black'
    }
    document.getElementsByClassName("optionImage")[index].style.borderColor  = 'yellow'
    setAnswerkey(option);
  }

  async function displayConversation() {
    if (numConversation1 <= props.names.length - 1) {
      setInstruction(getVideo(props.instructions[numConversation1], login));
      await GetUserVideo(
        `userfiles/${props.module.StudentID}/${props.names[numConversation1]}`
      ).then((data) => {
        setPlayVideo(data);
        setConversation1(true);
      });
    } else {
      setInstruction(getVideo(props.instructions[numConversation1], login));
      setConversation1(true);
    }
  }

  const onHit1 = (e) => {
    setOrder1(e.dragData.option);
    matchOptions[e.dragData.id] = null;
    setMatchOptions(matchOptions);
    setOrder1Visibility(e.dragData.id);
  };

  const onHit2 = (e) => {
    setOrder2(e.dragData.option);
    matchOptions[e.dragData.id] = null;
    setMatchOptions(matchOptions);
    setOrder2Visibility(e.dragData.id);
  };

  const onHit3 = (e) => {
    setOrder3(e.dragData.option);
    matchOptions[e.dragData.id] = null;
    setMatchOptions(matchOptions);
    setOrder3Visibility(e.dragData.id);
  };

  async function onDrag(option) {
    setAnimalVoice('');
    setAnimaTalk(false);
    //set a 500ms delay
    await sleep(500);
    setAnimalVoice(getVideo(option.audioPrompt, login));
    setAnimaTalk(true);
    setQuestion(false);
  }

  // The HTML code for the practice
  return (
    <>
      {displayAudio && (
        <audio
          autoPlay
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            setAudioReady(false);
            setDisplayAudio(false);
            setDisplayAnimal(false);
            if (animateAnimal === props.introduction) {
              setExample(true);
            } else if (animateAnimal === props.practiceMessage) {
              setDisplayInfluencer(true);
            } else if (animateAnimal === props.practiceConversation) {
              displayConversation();
            } else if (animateAnimal === props.awesomeJob) {
              if (props.module.reviewIcon === false) {
                dispatch({ type: props.stepComplete, payload: 'practice' });
              }
              props.setDisplayPractice(false);
            }
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}
      {practice && (
        <div
          className='practiceSituation'
          style={{ backgroundImage: `url(${props.background})` }}
        >
          <img
            className='back-btn-ftb'
            src={Exit}
            onClick={() => {
              props.setDisplayPractice(false);
            }}
          ></img>
          <br/>
          <h2 className='practiceSituationHeader'>{props.titles[step]}</h2>
          {changeText && <h3 className='practiceSituationQuestion'>{changeText}</h3>}

          {props.module16 && step === 0 && ( 
            <div className='videostep1'>
              <CloudfrontVideoFormat
                source={getVideo('appfiles/answer/practice_instructions.mp4', login)}
                ended={() => {
                  setStep(step + 1);
                }}
              /><div/>
            </div>)}

          {!(props.module16 && step === 0) && (
            <div className='gameGrid16'>
              <div className='optionImage16' onClick={() => setAnswer(option1, 0)}>
                  <img alt='Option 1' src={option1.img} />
                  {/* <h4 className='practiceText12'>{option1.title}</h4> */}
              </div>
              <div className='optionImage16' onClick={() => setAnswer(option2, 1)}>
                  <img alt='Option 2' src={option2.img} />
                  {/* <h4 className='practiceText12'>{option2.title}</h4> */}
              </div>
              <div className='optionImage16' onClick={() => setAnswer(option3, 2)}>
                  <img alt='Option 3' src={option3.img} />
                  {/* <h4 className='practiceText12'>{option3.title}</h4> */}
              </div>
            </div>
          )}
          {props.module19 && (
            <div className='bubbleSpeech'>
              <div className='bubbleText'>
                <img alt='' src={bubble} className='bubble' />
                <div alt='' className='centered'>
                  {speechBubble.text}
                </div>
              </div>
              <img alt='' className='secondAnimal' src={secondAnimal} />
              <img alt='' className='mainAnimal' src={props.animal} />
            </div>
          )}
          {(
            <img
              className={props.module19 ? 'greenCheckPractice19' : 'greenCheckPractice12'}
              style={{opacity : answerkey ? 1 : 0, pointerEvents : answerkey ? "auto" : "none"}}
              src={greenCheck}
              alt=''
              onClick={async() => {
                setAnimalVoice('');
                setAnimaTalk(false);
                if (keyword === answerkey.title) {
                  const audio = new Audio(
                    await generateImageUrl('media/Module1Videos/button_accept_item.mp3')
                  );
                  if(firstTime) setScore(score+1);
                  audio.play();
                  setStep(step + 1);
                  setFirstTime(true);
                } else {
                  setFirstTime(false)
                  let sound = new Audio(getVideo('appfiles/eye_contact/andrea_try_again.mp3', login));
                  sound.play();
                  setAnswerkey(null);
                }
              }}
            />
          )}
        </div>
      )}

      {matchGame && (
        <div
          className='practiceSituation'
          style={{ backgroundImage: `url(${props.background})` }}
        >
          <img
            className='back-btn-ftb'
            src={Exit}
            onClick={() => {
              props.setDisplayPractice(false);
            }}
          ></img>
          <br />
          <br />
          <h2 className='practiceSituationHeader'>{props.titles[step]}</h2>
          {changeText && <h3 className='practiceSituationQuestion'>{changeText}</h3>}
          <br />
          <div className='practiceSituationMatch'>
            <DropTarget
              targetKey=''
              onHit={(e) => {
                onHit1(e);
              }}
            >
            <h4>Step 1</h4>
              {
                <div className='practiceSituationBox'>
                  {order1 && (
                    <div
                      className='optionImage20'
                      onClick={() => setAnswer17(order1)}
                    >
                      <div className='set20'>
                        <img
                          alt=''
                          className='crabExpression20'
                          src={order1.img}
                        />
                        {/* <h4 className='practiceText12'>{order1.title}</h4> */}
                      </div>
                    </div>
                  )}
                </div>
              }
            </DropTarget>
            <DropTarget
              targetKey=''
              onHit={(e) => {
                onHit2(e);
              }}
            >
            <h4>Step 2</h4>
              {
                <div className='practiceSituationBox'>
                  {order2 && (
                    <div
                      className='optionImage20'
                      onClick={() => setAnswer17(order2)}
                    >
                      <div className='set20'>
                        <img
                          alt=''
                          className='crabExpression20'
                          src={order2.img}
                        />
                        {/* <h4 className='practiceText12'>{order2.title}</h4> */}
                      </div>
                    </div>
                  )}
                </div>
              }
            </DropTarget>
            <DropTarget
              targetKey=''
              onHit={(e) => {
                onHit3(e);
              }}
            >
            <h4>Step 3</h4>
              {
                <div className='practiceSituationBox'>
                  {order3 && (
                    <div
                      className='optionImage20'
                      onClick={() => setAnswer17(order3)}
                    >
                      <div className='set20'>
                        <img
                          alt=''
                          className='crabExpression20'
                          src={order3.img}
                        />
                        {/* <h4 className='practiceText12'>{order3.title}</h4> */}
                      </div>
                    </div>
                  )}
                </div>
              }
            </DropTarget>
          </div>
          {(
            <img
              className='greenCheckPractice'
              style={{opacity : (order1 && order2 && order3)  ? 1 : 0, pointerEvents : (order1 && order2 && order3) ? "auto" : "none", marginTop: '0px'}}
              src={greenCheck}
              alt=''
              onClick={() => {
                setAnimalVoice('');
                setAnimaTalk(false);
                if (
                  order1.title === 'Tell the bully to stop' &&
                  order2.title === 'Walk away and stay away' &&
                  order3.title === 'Tell an adult'
                ) {
                  const audio = new Audio(
                    generateImageUrl('media/Module1Videos/button_accept_item.mp3')
                  );
                  audio.play();
                  if(firstTime) setScore(score + 3);
                  setStep(step + 1);
                } else {
                  let sound = new Audio(getVideo('appfiles/eye_contact/andrea_try_again.mp3', login));
                  sound.play();
                  let total = 3;
                  if (order1.title !== 'Tell the bully to stop') {
                    matchOptions[order1Visibility] = order1;
                    setOrder1(null);
                    --total;
                  }
                  if (order2.title !== 'Walk away and stay away') {
                    matchOptions[order2Visibility] = order2;
                    setOrder2(null);
                    --total;
                  }
                  if (order3.title !== 'Tell an adult') {
                    matchOptions[order3Visibility] = order3;
                    setOrder3(null);
                    --total;
                  }
                  if(firstTime) setScore(score+total);
                  setFirstTime(false);
                  setMatchOptions(matchOptions);
                  (async () => {
                    setMatchGame(false);
                    await sleep(1);
                    setMatchGame(true);
                  })();
                }
              }}
            />
          )}
          <div className='practiceSituationGrid'>
            <div className='grid-item20'>
              <DragDropContainer
                dragData={{ option: matchOptions[0], id: 0 }}
                targetKey=''
                onDragStart={() => onDrag(matchOptions[0])}
              >
                {matchOptions[0] && (
                  <div className='optionImage16'>
                    <img alt='Option 1' src={matchOptions[0].img}/>
                  </div>
                )}
              </DragDropContainer>
            </div>
            <div className='grid-item20'>
              <DragDropContainer
                dragData={{ option: matchOptions[1], id: 1 }}
                targetKey=''
                onDragStart={() => onDrag(matchOptions[1])}
              >
                {matchOptions[1] && (
                  <div className='optionImage16'>
                    <img alt='Option 2' src={matchOptions[1].img}/>
                  </div>
                )}
              </DragDropContainer>
            </div>
            <div className='grid-item20'>
              <DragDropContainer
                dragData={{ option: matchOptions[2], id: 2 }}
                targetKey=''
                onDragStart={() => onDrag(matchOptions[2])}
              >
                {matchOptions[2] && (
                  <div className='optionImage16'>
                    <img alt='Option 3' src={matchOptions[2].img}/>
                  </div>
                )}
              </DragDropContainer>
            </div>
          </div>
          <button
            style={{
              position: 'absolute',
              bottom: '0',
              width: '140px',
              marginLeft: '-70px',
              height: '60px',
              fontWeight: 'bold',
              backgroundColor: 'rgb(255, 105, 105)',
              borderColor: 'rgb(255, 105, 105)',
            }}
            onClick={() => {
              reset();
            }}
          >
            Reset
          </button>
        </div>
      )}

      {recording && (
        <div
          id='recordpage'
          style={{ backgroundImage: `url(${props.background})` }}
        >
          <img
            className='back-btn-ftb'
            src={Exit}
            onClick={() => {
              props.setDisplayPractice(false);
            }}
          ></img>
          {takingVideo && (
            <VideoWebcamRecorder
              background={props.background}
              instruction={instruction}
              outputText={props.texts[numVideo]}
              name={props.names[numVideo]}
              voice={voice}
              close={props.setDisplayPractice}
              ended={() => {
                setNumVideo(numVideo + 1);
                setTakingVideo(false);
              }}
            />
          )}
          {displayAnimal && !audioReady && (
            <img alt='' id='loading' src={loading} />
          )}
          {displayAnimal && (
            <img
              className={animalSize}
              style={audioReady ? {} : { display: 'none' }}
              onLoad={() => setDisplayAudio(true)}
              src={animateAnimal}
            />
          )}
          {displayInfluencer && (
            <div id='influencerVideo'>
              <video
                style={videoPlayer}
                autoPlay
                controls={isIOS() ? showStart : false}
                onPlaying={() => {
                  setShowStart(false);
                }}
                onEnded={() => {
                  setAnimalVoice(getVideo(props.practiceConversationAudio, login));
                  setAnimateAnimal(props.practiceConversation);
                  setDisplayAnimal(true);
                  setDisplayInfluencer(false);
                }}
                onError={() => {
                  setAnimalVoice(getVideo(props.practiceConversationAudio, login));
                  setAnimateAnimal(props.practiceConversation);
                  setDisplayAnimal(true);
                  setDisplayInfluencer(false);
                }}
                playsInline
              >
                <source src={influencerVideo} type='video/mp4'></source>
              </video>
            </div>
          )}
          {example && (
          <CloudfrontVideoFormat
            source={props.exampleVideo}
            back='/unit4'
            background={props.background}
            close={props.setDisplayPractice}
            ended={() => {
              setExample(false);
              setTakingVideo(true);
            }}
          />)}
          {conversation1 && (
            <div id='borderVideo'>
              <video
                style={videoPlayer1}
                autoPlay
                controls={isIOS() ? showStart : false}
                onPlaying={() => {
                  setShowStart(false);
                }}
                onEnded={() => {
                  setConversation1(false);
                  if (numConversation1 > props.names.length - 1) {
                    setAnimateAnimal(props.awesomeJob);
                    setAnimalVoice(getVideo(props.awesomeJobAudio, login));
                    setDisplayAnimal(true);
                  } else {
                    setConversation2(true);
                  }
                }}
                onError={() => {
                  setConversation1(false);
                  if (numConversation1 > props.names.length - 1) {
                    setAnimateAnimal(props.awesomeJob);
                    setAnimalVoice(getVideo(props.awesomeJobAudio, login));
                    setDisplayAnimal(true);
                  } else {
                    setConversation2(true);
                  }
                }}
                playsInline
              >
                <source src={instruction} type='video/mp4'></source>
              </video>
            </div>
          )}
          {conversation2 && (
            <div id='border'>
              <video
                style={{ width: '391px', height: '580px', left: '50%' }}
                autoPlay
                controls={isIOS() ? showStart : false}
                onPlaying={() => {
                  setShowStart(false);
                }}
                onEnded={() => {
                  setConversation2(false);
                  if (numConversation1 === props.instructions.length - 1) {
                    setAnimateAnimal(props.awesomeJob);
                    setAnimalVoice(getVideo(props.awesomeJobAudio, login));
                    setDisplayAnimal(true);
                  } else {
                    setNumConversation1(numConversation1 + 1);
                  }
                }}
                onError={() => {
                  setConversation2(false);
                  if (numConversation1 === props.instructions.length - 1) {
                    setAnimateAnimal(props.awesomeJob);
                    setAnimalVoice(getVideo(props.awesomeJobAudio, login));
                    setDisplayAnimal(true);
                  } else {
                    setNumConversation1(numConversation1 + 1);
                  }
                }}
                playsInline
              >
                <source src={playVideo} type='video/mp4'></source>
              </video>
            </div>
          )}
        </div>
      )}
      {!animalTalk && question && (
        <audio
          autoPlay
          onEnded={() => {
            setQuestion(false);
            if (props.module16 && step === 0) {
              setStep(step + 1);
            } else if (props.module19) {
              setAnimalVoice(getVideo(speechBubble.phrase, login));
              setAnimaTalk(true);
            }
          }}
        >
          <source src={introSound}></source>
        </audio>
      )}
      {animalTalk && (
        <audio
          autoPlay
          onEnded={() => {
            setAnimaTalk(false);
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}
    </>
  );
};
export default PracticeSituation;
